import { Form, InputNumber } from 'antd';
import EmployeeSelectorComponent from '../../../shared/employee-selector/employee-selector.component';
import { Link } from 'react-router-dom';
import { useListEmployees } from '../../../utils/api-hooks/employee.hook';
import { useForm } from 'antd/es/form/Form';
import { RefObject, useEffect, useImperativeHandle, useMemo } from 'react';
import { FormInstance, Select } from 'antd';
import { includes, map, orderBy } from 'lodash';
import { DefaultOptionType } from 'antd/es/select';
import FormItem from 'antd/es/form/FormItem';
import {
  DEPARTMENT_EMPLOYEE_COMPENSATION_TYPE,
  DEPARTMENT_EMPLOYEE_COMPENSATION_TYPE_OPTIONS,
} from '../../../constants/department-employee';
import { EMPLOYEE_STATE_LABEL } from '../../../constants/employee';
import DepartmentSelectorContainer from '../../../shared/department-selector/department-selector.container';

type AddEmployeeFormProps = {
  formRef: RefObject<FormInstance>;
  disabledIds?: Array<string>;
  isAfterEmployeeCreated?: boolean;
  employeeId?: string;
  departmentId?: string;
  compensationType?: DEPARTMENT_EMPLOYEE_COMPENSATION_TYPE;
  amount?: number;
  defaultHours?: number;
};

export default function AddEmployeeFormComponent(props: AddEmployeeFormProps) {
  const {
    formRef,
    disabledIds,
    isAfterEmployeeCreated,
    employeeId,
    departmentId,
    amount,
    compensationType,
    defaultHours,
  } = props;
  const [form] = useForm();
  const { data: { data } = {}, isLoading } = useListEmployees();

  useImperativeHandle(formRef, () => form, [form]);

  useEffect(() => {
    if (employeeId) {
      form.setFieldsValue({ employeeId });
    }
    if (departmentId) {
      form.setFieldsValue({ departmentId });
    }
    if (amount) {
      form.setFieldsValue({ amount });
    }
    if (compensationType) {
      form.setFieldsValue({ compensationType });
    }
    if (defaultHours) {
      form.setFieldsValue({ defaultHours });
    }
  }, [employeeId, form, departmentId, compensationType, amount, defaultHours]);

  const employeeOptions: Array<DefaultOptionType> = useMemo(() => {
    return orderBy(
      map(data, (employee) => {
        const selected = includes(disabledIds, employee.id);
        const suspended = employee.state === 'SUSPENDED';

        return {
          label: `${employee.idNumber} - ${employee.name}${selected ? ' (已在部門內)' : ''} ${suspended ? ` (${EMPLOYEE_STATE_LABEL.SUSPENDED})` : ''}`,
          value: employee.id,
          disabled: selected || suspended,
        };
      }),
      ['disabled', 'label'],
      ['asc', 'asc']
    );
  }, [data, disabledIds]);

  return (
    <div className="w-full space-y-4">
      {!isAfterEmployeeCreated && (
        <div>
          如果想要新增的員工不在列表當中，請先到
          <Link to="/human-resource/employees">這裡</Link>新增
        </div>
      )}
      <Form
        form={form}
        initialValues={{
          compensationType: DEPARTMENT_EMPLOYEE_COMPENSATION_TYPE.HOURLY,
        }}
      >
        <EmployeeSelectorComponent
          disabled={isAfterEmployeeCreated}
          isRequired
          loading={isLoading}
          options={employeeOptions}
        />
        {isAfterEmployeeCreated && (
          <DepartmentSelectorContainer disabled={!!departmentId} />
        )}
        <span className="text-lg font-bold">薪資設定</span>
        <FormItem
          name="compensationType"
          label="薪資類型"
          rules={[{ required: true, message: '請選擇薪資類型' }]}
        >
          <Select
            popupClassName="z-50"
            options={DEPARTMENT_EMPLOYEE_COMPENSATION_TYPE_OPTIONS}
          />
        </FormItem>
        <FormItem
          name="amount"
          label="單位薪資(元)"
          rules={[{ required: true, message: '請輸入單位薪資' }]}
        >
          <InputNumber min={0} />
        </FormItem>
        <FormItem
          name="defaultHours"
          label="預設工時"
          rules={[{ required: true, message: '請輸入預設工時' }]}
        >
          <InputNumber min={1} />
        </FormItem>
      </Form>
    </div>
  );
}
